'use strict';

module.exports = {
	parse: require('./template-parser'),
	partials: require('./components/components')
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/index.js
// module id = 1
// module chunks = 0